module.exports = __webpack_public_path__ + "static/img/y16.6ed365d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/images/y16.jpg
// module id = pe/m
// module chunks = 1